import { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Button } from '@mui/material';
import Section from 'features/dynamicForm/components/Section/Section';
import { sectionTemplateType } from 'features/dynamicForm/types';

export default function ViewSectionTemplate({ sectionTemplate }) {
    const methods = useForm({ shouldUnregister: true });

    const onSubmit = (data) => {
        console.log('Submit data', data);
        alert(JSON.stringify(data, null, 2));
    };

    useEffect(() => {
        methods.reset();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sectionTemplate]);

    return (
        <div>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
                    <Section section={sectionTemplate?.form} />
                    <Button variant="contained" color="success" size="small" type="submit">
                        submit
                    </Button>
                </form>
            </FormProvider>
        </div>
    );
}

ViewSectionTemplate.propTypes = {
    sectionTemplate: sectionTemplateType,
};
